import { type RouteConfig } from 'vue-router'

export const PublicationRouter: RouteConfig[] = [
  {
    path: '/publications',
    component: async () => import('./Publications.vue'),
  },
]
